import template from "./onboarding-mode-message.html";

export default angular
	.module("vesl.screens.welcome.onboarding-mode-message", [])
	.component("onboardingModeMessage", {
		bindings: {
			selectedForm: "<"
		},
		template
	}).name;
